.list {
  box-sizing: border-box;
  position: relative;
}

.scrollable {
  box-sizing: border-box;
  font-size: 0;
  overflow-x: scroll;
  position: relative;
  scroll-behavior: smooth;
  scrollbar-width: none;
  white-space: nowrap;
  width: 100%;
}

.scrollable::-webkit-scrollbar {
  display: none;
}

.shadow {
  height: calc(var(--shadow-height) + 10px);
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  top: -5px;
  transition: opacity 0.2s ease-in-out;
  width: 60px;
  z-index: 9;
}

.shadow.more {
  right: 0;
}

.shadow.less {
  left: 0;
}

.shadow.hide {
  opacity: 0;
}

.shadow svg {
  color: var(--theme-dark-blue);
  cursor: pointer;
  height: 20px;
  opacity: 0.7;
  padding: calc((var(--shadow-height) - 10px) / 2) 20px;
  pointer-events: all;
  position: absolute;
  transition: opacity 0.2s ease-in-out;
}

@media (pointer: coarse) {
  .shadow svg {
    display: none;
  }
}

.shadow.hide svg {
  cursor: auto;
  pointer-events: none;
}

.shadow svg:hover {
  color: var(--theme-blue);
  opacity: 1;
}

.shadow.more svg {
  padding-right: var(--arrow-space);
  right: 0;
}

.shadow.less svg {
  left: 0;
  padding-left: var(--arrow-space);
}


@media print {
  .shadow {
    display: none;
  }
}